import useQueryParams from "./useQueryParams";
const QueryParams = _ref => {
  let {
    config,
    children
  } = _ref;
  const [query, setQuery] = useQueryParams(config);
  return children({
    query,
    setQuery
  });
};
var QueryParams_default = QueryParams;
export { QueryParams, QueryParams_default as default };